(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/views/start.js') >= 0) return;  svs.modules.push('/modules/iam-login/views/start.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.iam_login=_svs.iam_login||{};
_svs.iam_login.templates=_svs.iam_login.templates||{};
svs.iam_login.templates.start = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"containerRegion\" class=\"container-region js-react-container\"></div>\n";
},"useData":true});
Handlebars.partials['svs-iam_login-start'] = svs.iam_login.templates.start;
})(svs, Handlebars);


 })(window);